import { Injectable } from '@angular/core';
import { CloneDepth, Immutable, StateActionBranch } from 'immutablets';

import { LOCAL_STORAGE_LANG_KEY } from '../../common/constants';
import { UILanguage } from '../../core/providers/i18n/i18n.service';
import { AppState } from '../models/app-state.model';
import { UIState } from '../models/ui-state.model';

@Injectable()
@Immutable()
export class UIStateActions extends StateActionBranch<AppState> {
    @CloneDepth(1)
    private ui: UIState;

    constructor() {
        super({
            uses: ['ui'],
            initialState: {
                ui: {
                    currentLanguage: 'en',
                    searchAvailable: false
                }
            }
        });
    }

    setLanguage(newUiLanguage: UILanguage): void {
        this.ui.currentLanguage = newUiLanguage;
        localStorage.setItem(LOCAL_STORAGE_LANG_KEY, newUiLanguage);
    }

    setSearchAvailable(searchAvailable: boolean): void {
        this.ui.searchAvailable = searchAvailable;
    }
}
